export const UPDATED_COMPANY_PROFILE_ADMIN_NOTIFICATION = "UpdatedCompanyProfileAdminNotification";
export type UPDATED_COMPANY_PROFILE_ADMIN_NOTIFICATION_TYPE = "UpdatedCompanyProfileAdminNotification";
